import './index.css';
import * as React from 'react';
import { Dispatch, RootState } from '@/src/pages/homepage/quality_special_page_main/models/store';
import { connect } from '@wmfe/mach-pro-store';
import { backToTopBtnBid, qualitySpecialPageCid } from '@/src/pages/homepage/quality_special_page_main/utils/constant';
import { ScenceTabItemData } from './component';
import ScenceTabItem from './ScenceTabItem';
import ScenceTabTextItem from './ScenceTabTextItem';
// import {Props} from "@/components/MultiSkuModal/Components/MultiSpuLandscapeListView/types";

const mapStateToProps = (state: RootState, dispatch: Dispatch) => ({
  selectedScenceTab: state.global.selectedScenceTab
});

const Statistics = Mach.requireModule('Statistics');

type BaseIProps = ReturnType<typeof mapStateToProps>;

interface State {

}

interface Props extends BaseIProps {
  cid: string;
  moduleData: any;
  onClickItem: (item: ScenceTabItemData) => void;
}

/**
 * 通用tab组件
 */
class ScenceTab extends React.Component<Props, State> {
  scrollerRef: any = null
  constructor(props) {
    super(props);
  }

  componentDidMount(): void {
    this.reportMV(this.props.moduleData);
  }

  componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any) {
    this.reportMV(nextProps.moduleData);
  }

  data_id = ''
  reportMV = (apiData) => {
    const params = {
      tab_index: '-999',
      tab_name: '-999',
    };
    if (this.data_id !== apiData.data_id) {
      const { cid } = this.props;
      Statistics.view(cid, 'b_sailor_c_nyx44sps_mv', params);
      if (this.scrollerRef) {
        this.scrollerRef.scrollToOffset({ x: 0, y: 0 }, false);
      }
      this.data_id = apiData.data_id;
    }
  }

  componentWillUnmount(): void {

  }

  private isItemSelected(item: ScenceTabItemData): boolean {
    const propsTabKey = this.props.selectedScenceTab?.tabKey;
    const itemTabKey = item?.tabKey;
    if (propsTabKey && itemTabKey && propsTabKey.length > 0 && itemTabKey.length > 0) {
      return item?.tabKey === this.props.selectedScenceTab?.tabKey;
    }
    return item?.supplyId === this.props.selectedScenceTab?.supplyId;
  }

  render() {
    const { json_data, layout_info } = this.props.moduleData;
    const { tabList, displayStyle } = json_data;
    // AB样式控制
    const sceneTabStyle = displayStyle || 0; // 0图片+文案、1文案
    const tabHeight = Number(sceneTabStyle) === 1 ? 36 : 96;
    const {
      margin_top, margin_bottom, margin_left, margin_right
    } = layout_info || {};
    const { padding_left, padding_right } = layout_info || {};

    return (
      <view style={{
        width: '100%', height: tabHeight, marginTop: margin_top, marginBottom: margin_bottom, marginLeft: margin_left, marginRight: margin_right
      }}
      >
        <scroller showScrollIndicator={false} ref={(ref: any) => { this.scrollerRef = ref; }}>
          <content style={{ paddingLeft: padding_left || 12, paddingRight: padding_right }}>
            {tabList.map((item: ScenceTabItemData, index) => (
              <view
                key="" onClick={() => {
                  const params = {
                    tab_index: index,
                    tab_name: item.text || '',
                  };
                  Statistics.click(this.props.cid, 'b_sailor_c_nyx44sps_mc', params);
                  this.props.onClickItem(item);
                }}
              >
                {Number(sceneTabStyle) === 0 && <ScenceTabItem key="" scenceTabData={item} isSelected={this.isItemSelected(item)} />}
                {Number(sceneTabStyle) === 1 && <ScenceTabTextItem key="" scenceTabData={item} isSelected={this.isItemSelected(item)} />}
              </view>
            ))}
          </content>
        </scroller>
      </view>
    );
  }
}
export default connect(mapStateToProps)(ScenceTab);
